module.exports = __webpack_public_path__ + "akne_3_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/akne_3_before.jpg
// module id = 920
// module chunks = 0